import { render, staticRenderFns } from "./Implantados.vue?vue&type=template&id=84e22eb8&scoped=true&lang=pug&"
import script from "./Implantados.vue?vue&type=script&lang=js&"
export * from "./Implantados.vue?vue&type=script&lang=js&"
import style0 from "./Implantados.vue?vue&type=style&index=0&id=84e22eb8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e22eb8",
  null
  
)

export default component.exports